import { useCompany } from "../contexts/CompanyContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Building2, AlertCircle, ChevronDown } from "lucide-react";

const CompanySelector = () => {
  const { companies, selectedCompany, selectCompany, loading } = useCompany();

  if (loading) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-indigo-50 rounded-xl">
        <Building2 className="w-5 h-5 text-indigo-400 animate-pulse" />
        <span className="text-sm text-indigo-500">Chargement...</span>
      </div>
    );
  }

  if (companies.length === 0) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-amber-50 rounded-xl border border-amber-200">
        <AlertCircle className="w-5 h-5 text-amber-500" />
        <span className="text-sm font-medium text-amber-700">Aucune société</span>
      </div>
    );
  }

  if (companies.length === 1) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-indigo-50 rounded-xl">
        <Building2 className="w-5 h-5" style={{ color: companies[0].color || "#4f46e5" }} />
        <span className="text-sm font-semibold text-indigo-700">{companies[0].name}</span>
      </div>
    );
  }

  return (
    <Select
      value={selectedCompany?.id || ""}
      onValueChange={(value) => {
        const company = companies.find((c) => c.id === value);
        selectCompany(company);
      }}
    >
      <SelectTrigger
        data-testid="company-selector"
        className="min-w-[180px] h-10 bg-indigo-50 border-indigo-200 rounded-xl hover:bg-indigo-100 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Building2 className="w-5 h-5 text-indigo-600" />
          <span className="font-semibold text-indigo-700">
            <SelectValue placeholder="Société" />
          </span>
        </div>
      </SelectTrigger>
      <SelectContent className="rounded-xl">
        {companies.map((company) => (
          <SelectItem key={company.id} value={company.id} className="rounded-lg">
            <div className="flex items-center gap-3 py-1">
              <div
                className="w-3 h-3 rounded-full ring-2 ring-offset-1"
                style={{ backgroundColor: company.color || "#4f46e5", ringColor: company.color || "#4f46e5" }}
              />
              <span className="font-medium">{company.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CompanySelector;
